import React, { useState, useRef, useEffect } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { Modal, Button } from 'react-bootstrap';

const QRCodeScanner = ({ isScann, setScanning, getQRCodeString }) => {
  const qrCodeScannerRef = useRef(null);
  const [qrCodeResult, setQrCodeResult] = useState(null);

  useEffect(() => {
    const startQrScanner = async () => {
      try {
        const qrCodeScanner = new Html5Qrcode("qr-reader");

        const devices = await Html5Qrcode.getCameras();
        let backCameraId = null;

        // Try to find the back camera device
        for (const device of devices) {
          if (device.label.toLowerCase().includes('back')) {
            backCameraId = device.id;
            break;
          }
        }

        // Fallback to the first available camera if no back camera is found
        const cameraId = backCameraId || devices[0]?.id;

        if (cameraId) {
          qrCodeScanner.start(
            cameraId, // use the selected camera ID
            {
              fps: 10, // Frame per second for QR code scan
              qrbox: { width: 250, height: 250 }, // Scan box size
            },
            (decodedText) => {
              // Handle decoded QR code
              getQRCodeString(decodedText);
              setQrCodeResult(decodedText);
              setScanning(false);
            },
            (errorMessage) => {
              // Handle scan errors or failures
              console.warn("QR Code Scan Error:", errorMessage);
            }
          );
          qrCodeScannerRef.current = qrCodeScanner;
        } else {
          console.error("No cameras found.");
        }
      } catch (err) {
        console.error("Error initializing QR Code scanner:", err);
      }
    };

    if (isScann) {
      startQrScanner();
    } else if (qrCodeScannerRef.current) {
      qrCodeScannerRef.current.stop().then(() => {
        qrCodeScannerRef.current.clear();
        setScanning(false);
      }).catch((err) => {
        setScanning(false);
        console.error("Failed to stop scanning", err);
      });
    }

    // Clean up when the component is unmounted or scan is stopped
    return () => {
      if (qrCodeScannerRef.current) {
        qrCodeScannerRef.current.stop().then(() => {
          qrCodeScannerRef.current.clear();
        });
      }
    };
  }, [isScann, setScanning, getQRCodeString]);

  const stopScan = () => {
    if (qrCodeScannerRef.current) {
      qrCodeScannerRef.current.stop().then(() => {
        qrCodeScannerRef.current.clear();
        setScanning(false);
      }).catch((err) => {
        setScanning(false);
        console.error("Failed to stop scanning", err);
      });
    }
  };

  return (
    <div>
      <Modal show={isScann} onHide={stopScan}>
        <Modal.Header closeButton>
          <Modal.Title>Scan QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="qr-reader" style={{ width: '100%', height: '100%', margin: '20px auto' }}></div>
          {qrCodeResult && (
            <div>
              <h3>QR Code Result:</h3>
              <p>{qrCodeResult}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={stopScan}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default QRCodeScanner;
